export var findNodeByClass = function findNodeByClass($el, className) {
  var childArr = $el.children;
  var res = null;

  if (childArr.length) {
    for (var i = 0; i < childArr.length; i++) {
      if (childArr[i].classList.contains(className)) {
        res = childArr[i];
        break;
      } else {
        res = findNodeByClass(childArr[i], className);

        if (res) {
          break;
        }
      }
    }

    return res;
  }

  return null;
};